export const ALL_REPORT_REQUEST = "ALL_REPORT_REQUEST";
export const ALL_REPORT_SUCCESS = "ALL_REPORT_SUCCESS";
export const ALL_REPORT_FAIL = "ALL_REPORT_FAIL";

export const CREATE_ADMIN_BLOCK_REPORT_REQUEST = "CREATE_ADMIN_BLOCK_REPORT_REQUEST";
export const CREATE_ADMIN_BLOCK_REPORT_SUCCESS = "CREATE_ADMIN_BLOCK_REPORT_SUCCESS";
export const CREATE_ADMIN_BLOCK_REPORT_FAIL = "CREATE_ADMIN_BLOCK_REPORT_FAIL";